export default "__VITE_ASSET__DLa32X$m__"